import { fetchWithAuth } from "@/api/fetchApi";

// 🔹 ルーム一覧を取得
// filterUnitySync=true: VR デバイス同期 OFF の共有ルームをサーバ側で除外
// （OperationView / Poranos Desktop / Unity と同じセマンティクス）
export async function fetchRooms({ filterUnitySync = false } = {}) {
  const headers = filterUnitySync ? { "X-Filter-Unity-Sync": "true" } : {};
  return fetchWithAuth("/rooms/", { headers });
}

// 🔹 ルームを作成
export async function createRoom(name) {
  return fetchWithAuth("/rooms/", {
    method: "POST",
    body: JSON.stringify({ name: name || "" }),
  });
}

// 🔹 ルームを更新
export async function updateRoom(updatedRoom) {
  return fetchWithAuth(`/rooms/${updatedRoom.id}/`, {
    method: "PUT",
    body: JSON.stringify({ name: updatedRoom.name }),
  });
}

export async function updateRoomOrderAPI(newOrder) {
  return fetchWithAuth(`/rooms/update_order/`, {
    method: "POST",
    body: JSON.stringify(newOrder),
  });
}

// 🔹 共有ルームの VR デバイス同期 ON/OFF を切り替え
export async function setRoomUnitySyncAPI(roomId, enabled) {
  return fetchWithAuth(`/rooms/${roomId}/set_unity_sync/`, {
    method: "POST",
    body: JSON.stringify({ enabled }),
  });
}
